import { BadgeSelect } from "./components/Modal/BadgeSelect/index.js";
import { Checkbox } from "./components/Modal/Checkbox/index.js";
import { Disclosure } from "./components/Modal/Disclosure/index.js";
import { Footer } from "./components/Modal/Footer/index.js";
import { Header } from "./components/Modal/Header/index.js";
import { InputFields } from "./components/Modal/InputFields/index.js";
import { Modal as Modal$1 } from "./components/Modal/Modal/index.js";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { compact, partition, sortBy, groupBy, xor, intersection, difference, union } from "lodash";
import { ActionIcon } from "./components/ActionIcon/index.js";
import { Button } from "./components/Button/index.js";
import { CheckboxInput } from "./components/Checkbox/index.js";
import { Icons24 } from "./components/Icons24Sprite/index.js";
import { ComboboxField, InputField } from "./components/InputFields/InputField/index.js";
import { Radio } from "./components/Modal/Radio/index.js";
import { Section } from "./components/Modal/Section/index.js";
import { SectionHeader } from "./components/Modal/SectionHeader/index.js";
import { Switch } from "./components/Modal/Switch/index.js";
import { Text } from "./components/Modal/Text/index.js";
import { O as OptionList } from "./index-BX4X-L-0.js";
import './assets/index64.css';const layout = "_layout_rqqxg_1";
const layoutScrollContainer = "_layoutScrollContainer_rqqxg_6";
const emptyState = "_emptyState_rqqxg_14";
const s = {
  layout,
  layoutScrollContainer,
  emptyState
};
const ModalCombobox = (props) => {
  const { items, multiple, value, onChange, title, submitTitle, parentModalRef, hideSearch, emptySearchText } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  useEffect(() => {
    setQuery("");
  }, [isOpen]);
  const selectedItems = compact(
    value.map((item) => items.find((i) => "value" in i && i.value === item))
  );
  const removeBadgeByIndex = (index) => {
    const newItems = [...value];
    newItems.splice(index, 1);
    onChange(newItems);
  };
  const visibleItems = items.filter((item) => {
    var _a;
    return (_a = item.title) == null ? void 0 : _a.toString().toLowerCase().includes(query.toLowerCase());
  });
  let [visibleItemsWithGroups, visibleItemsWithoutGroups] = partition(visibleItems, (i) => i.group);
  const groupedItems = sortBy(Object.entries(groupBy(visibleItemsWithGroups, "group")), (p) => p[0]);
  const renderItem = (item) => {
    return /* @__PURE__ */ jsx(
      OptionList.Item,
      {
        icon: /* @__PURE__ */ jsx(CheckboxInput, { checked: value.includes(item.value), indeterminate: false }),
        onClick: () => {
          if (multiple) {
            onChange(xor(value, [item.value]));
          } else {
            onChange([item.value]);
          }
        },
        label: item.title,
        className: item.className
      },
      item.key
    );
  };
  const getGroupValues = (group) => items.filter((item) => item.group === group).map((item) => item.value);
  const getGroupCheckedStatus = (group) => {
    let isChecked = false;
    let isIndeterminate = false;
    const groupValues = getGroupValues(group);
    const selectedCount = intersection(groupValues, value).length;
    if (selectedCount === groupValues.length) {
      isChecked = true;
    } else if (selectedCount > 0 && selectedCount < groupValues.length) {
      isIndeterminate = true;
    }
    return {
      isChecked,
      isIndeterminate
    };
  };
  const toggleGroup = (group) => {
    const groupValues = getGroupValues(group);
    const { isChecked } = getGroupCheckedStatus(group);
    if (isChecked) {
      onChange(difference(value, groupValues));
    } else {
      onChange(union(value, groupValues));
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(ComboboxField, { children: [
      selectedItems.map((item, index) => /* @__PURE__ */ jsx(
        ComboboxField.Badge,
        {
          className: item.className,
          closeButton: /* @__PURE__ */ jsx(ComboboxField.CloseButton, { onClick: () => removeBadgeByIndex(index) }),
          children: item.title
        },
        item.key
      )),
      /* @__PURE__ */ jsx(ComboboxField.InputSection, { children: /* @__PURE__ */ jsx(ComboboxField.Input, { placeholder: title, value: "", onFocus: () => setIsOpen(true) }) })
    ] }),
    /* @__PURE__ */ jsxs(
      Modal,
      {
        isOpen,
        onOpenStateChange: setIsOpen,
        parentModalRef,
        copyParentHeight: true,
        theme: "light",
        children: [
          /* @__PURE__ */ jsx(
            Modal.Header,
            {
              sticky: true,
              label: title,
              leftSection: /* @__PURE__ */ jsx(ActionIcon, { actionIconType: "ghost", icon: /* @__PURE__ */ jsx(Icons24, { name: "NavLeft" }), onClick: () => setIsOpen(false) }),
              rightSection: /* @__PURE__ */ jsx(ActionIcon, { actionIconType: "ghost", icon: /* @__PURE__ */ jsx(Icons24, { name: "Close" }), onClick: () => setIsOpen(false) })
            }
          ),
          /* @__PURE__ */ jsxs(Modal.Section, { withoutPadding: true, className: s.layout, children: [
            !hideSearch && /* @__PURE__ */ jsxs(InputField, { inline: true, fill: true, className: s.searchField, children: [
              /* @__PURE__ */ jsx(InputField.Affix, { leftIcon: /* @__PURE__ */ jsx(Icons24, { name: "Search" }) }),
              /* @__PURE__ */ jsx(
                InputField.Input,
                {
                  value: query,
                  placeholder: title,
                  onChange: ({ target }) => setQuery(target.value)
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("div", { className: s.layoutScrollContainer, children: [
              visibleItems.length === 0 && /* @__PURE__ */ jsx("div", { className: s.emptyState, children: emptySearchText }),
              /* @__PURE__ */ jsxs(OptionList.Group, { children: [
                groupedItems.map(([group, items2]) => {
                  const { isChecked, isIndeterminate } = getGroupCheckedStatus(group);
                  return /* @__PURE__ */ jsx(
                    OptionList.Group,
                    {
                      forceHideBorder: true,
                      expandable: true,
                      expandableItemProps: {
                        icon: multiple && /* @__PURE__ */ jsx(
                          CheckboxInput,
                          {
                            onClick: () => multiple && toggleGroup(group),
                            checked: isChecked,
                            indeterminate: isIndeterminate
                          },
                          isChecked.toString()
                        ),
                        label: group
                      },
                      children: items2.map((item) => renderItem(item))
                    },
                    `group-${group}`
                  );
                }),
                visibleItemsWithoutGroups.map((item) => renderItem(item))
              ] })
            ] })
          ] }),
          /* @__PURE__ */ jsx(Modal.Footer, { sticky: true, children: /* @__PURE__ */ jsx(Button, { intent: "primary", onClick: () => setIsOpen(false), children: submitTitle }) })
        ]
      }
    )
  ] });
};
ModalCombobox.displayName = "ModalCombobox";
const Modal = Object.assign(Modal$1, {
  Checkbox,
  Disclosure,
  Radio,
  Section,
  SectionHeader,
  Switch,
  Text,
  Footer,
  Header,
  InputFields,
  BadgeSelect,
  ModalCombobox
});
export {
  Modal as M,
  ModalCombobox as a
};
